(() => {
  "use strict";

    const initialize = (root) => {
    const quantity = root.querySelector('[name="quantity"]');
    const quantityButtons = [...root.querySelectorAll('[data-quantity-step]')];
    const changeQuantity = (event) => {
      if (!quantity) return;
      if (!Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
      if (Number(event.currentTarget.dataset.quantityStep) > 0) quantity.stepUp();
      else quantity.stepDown();
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    };
    quantityButtons.forEach(button => button.addEventListener('click', changeQuantity));
    const mainImage = root.querySelector("[data-product-main-image]");
    const thumbnails = [...root.querySelectorAll("[data-product-thumbnail]")];
    const variantSelect = root.querySelector("[data-product-variant]");
    const variantButtons = [...root.querySelectorAll("[data-product-variant-button]")];
    const selectedVariant = root.querySelector("[data-product-selected-variant]");
    const price = root.querySelector("[data-product-price]");
    const compare = root.querySelector("[data-product-compare]");
    const addButton = root.querySelector("[data-product-add]");
    const addLabel = root.dataset.addLabel || "Add to bag";
    const soldOutLabel = root.dataset.soldOutLabel || "Sold out";

    const normalizeImage = (rawUrl) => {
      if (!rawUrl) return "";

      try {
        return new URL(rawUrl, window.location.href).href;
      } catch (error) {
        return rawUrl;
      }
    };

    const syncActiveThumbnail = (selectedUrl) => {
      if (!thumbnails.length) return;

      const selectedImage = normalizeImage(selectedUrl);

      thumbnails.forEach((thumbnail) => {
        const match = normalizeImage(thumbnail.dataset.image) === selectedImage;
        thumbnail.classList.toggle("is-active", match);
        thumbnail.setAttribute("aria-pressed", match ? "true" : "false");
      });
    };

    const showImage = (url, alt = "") => {
      if (!mainImage || !url) return;
      mainImage.classList.add("is-changing");
      const preload = new Image();
      const apply = (resolvedSrc = url) => {
        mainImage.src = resolvedSrc;
        if (mainImage.srcset) {
          mainImage.removeAttribute("srcset");
          mainImage.srcset = "";
        }
        mainImage.alt = alt;
        mainImage.classList.remove("is-changing");
      };

      preload.onload = () => {
        apply(preload.src);
      };
      preload.onerror = () => apply();
      preload.src = url;
    };

    const onThumbnailClick = (event) => {
      const button = event.currentTarget;
      thumbnails.forEach((thumbnail) => {
        thumbnail.classList.toggle("is-active", thumbnail === button);
        thumbnail.setAttribute("aria-pressed", thumbnail === button ? "true" : "false");
      });
      showImage(button.dataset.image, button.dataset.alt || "");
    };

    const onVariantChange = () => {
      const option = variantSelect?.selectedOptions[0];
      if (!option) return;

      variantButtons.forEach((button) => {
        const selected = button.dataset.variantId === option.value;
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-pressed", selected ? "true" : "false");
      });
      if (selectedVariant) selectedVariant.textContent = option.textContent.replace(/\s+—\s+.*$/, "").trim();

      thumbnails.forEach((thumbnail) => {
        if (thumbnail.dataset.variantMedia !== "true") return;
        const variantIds = (thumbnail.dataset.variantIds || "").split(",").map((id) => id.trim()).filter(Boolean);
        thumbnail.hidden = !variantIds.includes(option.value);
      });

      if (price) price.textContent = option.dataset.price || "";
      if (compare) {
        compare.textContent = option.dataset.compare || "";
        compare.hidden = !option.dataset.compare;
      }

      const available = option.dataset.available === "true";
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? addLabel : soldOutLabel;
      }

      if (option.dataset.image) {
        showImage(option.dataset.image, option.textContent.trim());
        syncActiveThumbnail(option.dataset.image);
      }

      const url = new URL(window.location.href);
      url.searchParams.set("variant", option.value);
      window.history.replaceState({}, "", url);
    };

    const onVariantButtonClick = (event) => {
      if (!variantSelect) return;
      const button = event.currentTarget;
      if (!button.dataset.variantId) return;
      variantSelect.value = button.dataset.variantId;
      variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
    };

    thumbnails.forEach((thumbnail) => thumbnail.addEventListener("click", onThumbnailClick));
    variantButtons.forEach((button) => button.addEventListener("click", onVariantButtonClick));
    variantSelect?.addEventListener("change", onVariantChange);

    return () => {
      quantityButtons.forEach(button => button.removeEventListener('click', changeQuantity));
      thumbnails.forEach((thumbnail) => thumbnail.removeEventListener("click", onThumbnailClick));
      variantButtons.forEach((button) => button.removeEventListener("click", onVariantButtonClick));
      variantSelect?.removeEventListener("change", onVariantChange);
    };
  };

  if (window.ReneoraTheme) {
    window.ReneoraTheme.register("main-product", "[data-reneora-product]", initialize);
  }
})();
